module.exports = __webpack_public_path__ + "static/media/farroupilha.4370104c.png";